import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, companiesActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, companiesActions);

export default slice.reducer;
